import { FILTERS_MODAL } from 'components/Scroller/constants';
import Ship from 'components/ShipCard';
import { CruiseSearchContext } from 'contexts/CruiseSearchContext';
import { SHIP } from 'contexts/CruiseSearchContext/constants';
import { useContext, useEffect, useRef, useState } from 'react';

import classNames from 'classnames';
import { gsap } from 'gsap';

import Header from 'components/FiltersModal/Header';
import { Constrain, SectionTitle } from 'components/FiltersModal/components';
import { Button, ButtonWrap, Grid } from './components';

import { FILTERS_SEARCH_BAR } from '../../constants';
import FilterSearchBar from '../FilterSearchBar';

import SwitchComponent from 'components/SwitchComponent';
import { getBrandUISettings } from 'lib/utilities/Brands';
import { useFeatureFlags } from '../../../../hooks/LaunchDarkly/useFeatureFlags';

import CustomFilters from '../CustomFilters';

export const SHIPS_OPTIONS = {
	key: SHIP,
	label: 'All our Ships',
	options: [],
};

/**
 * Ships
 *
 * The Ships filter component listens to/sets the ship param of the search query.
 */

const Ships = () => {
	const sectionTitleRef = useRef();

	const {
		filterOptionsDictionary,
		removeFromSearchSelectingFilter,
		addToSearchSelectingFilter,
		searchSelecting,
		resetSearchSelectingFilter,
		globalization,
		facetOptions,
		fetchAndUpdateFacetOptions,
		brand,
	} = useContext(CruiseSearchContext);
	const { uiSettings } = getBrandUISettings(brand);
	const { showImagesInShipsFilter } = useFeatureFlags();

	const [optionsLoaded, setOptionsLoaded] = useState(filterOptionsDictionary?.destination);
	const { custom = [] } = filterOptionsDictionary || {};

	const { filtersDictionary } = globalization?.dictionaries || {};
	const { navShips, inputShipsSearchPlaceholder, labelAllOurShips, labelSpecialShips } = filtersDictionary;

	if (optionsLoaded) {
		SHIPS_OPTIONS.options = filterOptionsDictionary?.ship?.options || [];
	}

	useEffect(() => {
		if (filterOptionsDictionary?.destination) {
			setOptionsLoaded(true);
		}
	}, [filterOptionsDictionary?.destination, optionsLoaded]);

	const updateShips = (code) => {
		if (searchSelecting?.[SHIPS_OPTIONS.key]?.includes(code)) {
			removeFromSearchSelectingFilter(SHIPS_OPTIONS.key, code, fetchAndUpdateFacetOptions);
		} else {
			addToSearchSelectingFilter(SHIPS_OPTIONS.key, code, fetchAndUpdateFacetOptions);
		}
	};

	const resetFilterOptions = () => {
		resetSearchSelectingFilter(SHIP, fetchAndUpdateFacetOptions);
	};

	useEffect(() => {
		gsap.set(sectionTitleRef.current, {
			opacity: 0,
		});
		gsap.to(sectionTitleRef.current, {
			opacity: 1,
			duration: 0.25,
			ease: 'cubic-bezier(0,0,0,0)',
			stagger: 0.1,
		});
	}, []);

	const listShips = Array.isArray(SHIPS_OPTIONS.options) ? SHIPS_OPTIONS.options : [];

	listShips.sort((a, b) => (a.label > b.label ? 1 : -1));

	return (
		<>
			<Header title={navShips} onReset={() => resetFilterOptions()} />
			<Constrain ref={sectionTitleRef}>
				<FilterSearchBar
					searchesAllowing={[SHIPS_OPTIONS.key]}
					scrollerId={FILTERS_MODAL}
					placeholder={inputShipsSearchPlaceholder}
					container={FILTERS_SEARCH_BAR.SHIP}
				/>
				{custom?.options?.length > 0 && <CustomFilters title={labelSpecialShips} keyName={'filter_ship'} />}
				<SectionTitle title={labelAllOurShips} />
				<Grid showImage={showImagesInShipsFilter} gap={uiSettings.filtersModal.filtersGrid.gap}>
					{listShips.map((option, i) => {
						const selected = searchSelecting[SHIP]?.includes(option.code);
						const disabled = !facetOptions[SHIP]?.[option.code]?.count > 0;
						return (
							<SwitchComponent toogle={showImagesInShipsFilter} key={`${SHIPS_OPTIONS.key}-${option.code}`}>
								<Ship
									index={i}
									option={option}
									scrollerId={FILTERS_MODAL}
									key={`${SHIPS_OPTIONS.key}-${option.code}`}
									updateSelection={() => updateShips(option.code)}
									selected={selected}
									disabled={selected ? false : disabled}
								/>
								<ButtonWrap
									key={`${option.label}-${i}`}
									className={classNames({
										disabled: selected ? false : disabled,
									})}
								>
									<Button id={`ship-card-label-${option.code}`} showX={false} onClick={() => updateShips(option.code)} selected={selected}>
										{option.label}
									</Button>
								</ButtonWrap>
							</SwitchComponent>
						);
					})}
				</Grid>
			</Constrain>
		</>
	);
};

export default Ships;
